import { render, staticRenderFns } from "./Card-simple-actu.vue?vue&type=template&id=73eec542&"
import script from "./Card-simple-actu.vue?vue&type=script&lang=js&"
export * from "./Card-simple-actu.vue?vue&type=script&lang=js&"
import style0 from "./Card-simple-actu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports